import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports"},[_c('h1',{staticClass:"subheading grey--text"},[_vm._v("Reports")]),_c(VContainer,{staticClass:"my-5"},[_vm._v(" content ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }